module.exports = __webpack_public_path__ + "img/product-desc1.d1953078.png";